import React from 'react';
import mapNodes from 'helpers/mapNodes';
import PropTypes from 'prop-types';
import ProductsPage from 'components/ProductsPage';

const propTypes = {
  data: PropTypes.shape({
    allMarketTapProduct: PropTypes.object,
    allMarketTapProductCategory: PropTypes.object,
  }).isRequired,

  pathContext: PropTypes.shape({ selectedCategoryId: PropTypes.string })
    .isRequired,
};

function ProductsPageContainer({ data, pathContext }) {
  return (
    <ProductsPage
      products={mapNodes(data.allMarketTapProduct)}
      productCategories={mapNodes(data.allMarketTapProductCategory)}
      selectedCategoryId={pathContext.selectedCategoryId}
      seoTitle={pathContext.seoTitle}
      seoKeywords={pathContext.seoKeywords}
      seoDescription={pathContext.seoDescription}
    />
  );
}

ProductsPageContainer.propTypes = propTypes;

export default ProductsPageContainer;

export const query = graphql`
  query ProductsPageQuery {
    allMarketTapProduct {
      edges {
        node {
          id
          slug
          name
          excerpt
          description
          bannerImageUrl {
            thumbnail
          }
          benefitsAndDeliverables
          prices {
            cad {
              formattedPrice
            }
            usd {
              formattedPrice
            }
          }
          productCategoryIds
          productCategories {
            slug
            name
          }
        }
      }
    }

    allMarketTapProductCategory {
      edges {
        node {
          id
          slug
          name
          seoTitle
          seoKeywords
          seoDescription
          productIds
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/services.js